import React from 'react'
import { fromJS } from 'immutable'

/**
 * @param publish function(this)
 */
class EventMessage extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            queue: fromJS([]),
            current: undefined,
            shown: false
        }
    }

    componentDidMount()
    {
        if (this.props.publish) {
            this.props.publish(this)
        }
    }

    show(text)
    {
        this.setState({ queue: this.state.queue.push(fromJS({ key: Math.random(), text: text })) }, this._next.bind(this))
    }

    _next()
    {
        if (!this.state.shown)
        {
            const current = this.state.queue.size ? this.state.queue.get(0) : null
            this.setState({
                current: current,
                queue: this.state.queue.size ? this.state.queue.remove(0) : fromJS([]),
                shown: current != null
            })
            if (current != null)
            {
                setTimeout(() => {
                    this.setState({ shown: false }, this._next.bind(this))
                }, 3500)
            }
        }
    }

    render()
    {
        let eventMessage = this.state.current && this.state.shown ? (
            <div className="event-message" key={ this.state.current.get("key") }>{ this.state.current.get("text") }</div>
        ) : null

        return (
            <div className="event-message-container">
                { eventMessage }
            </div>
        )
    }

}

export default EventMessage
export { EventMessage }